module.exports = __webpack_public_path__ + "img/04my_product.3811147c.png";